import {ChangeDetectorRef, Input, SimpleChanges} from "@angular/core";
import {ControlValueAccessor} from "@angular/forms";

export class CclControlValueAccessor implements ControlValueAccessor {
    constructor(public cdr: ChangeDetectorRef) {
    }

    // ç¦ç¨ç¶æ
    @Input()
    disabled = false;
    // ç¦ç¨ç¶æ
    @Input()
    readonly = false;

    value: any;
    onChange: any; // å½ç»ä»¶å¼åçååæ¶ï¼è°ç¨ï¼ç¨ä»¥æ¨é Control
    onTouched: any; // å½ç»ä»¶ç¹å»æ¶è°ç¨ï¼ç¨ä»¥æ¨é Control

    // å¤é¨ Control æ³¨åçchangeäºä»¶ï¼ä¿çå° this ä¸ï¼å½ç»ä»¶å¼åçååæ¶ï¼æ¹ä¾¿éç¥Control
    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    // å¤é¨ Control æ³¨åçtouchedäºä»¶ï¼ä¿çå° this ä¸ï¼å½ç»ä»¶åçtouchedæä½æ¶ï¼æ¹ä¾¿éç¥Control
    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    // å¤é¨ Control ç¦ç¨ç¶æåçååæ¶ï¼å°å¼è®¾ç½®ç» select
    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }

    writeValue(obj: any): void {
        throw new Error('this method must be realized');
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.disabled) {
            setTimeout(() => this.cdr.markForCheck());
        }
    }
}
